import { action } from 'mobx';
import {
    PageTaskRepresentation,
    TaskRepresentation,
} from 'src/generated-api-client';
import { taskManagerApi } from 'src/services/apiServices';
import { AsyncOperationWithStatus } from 'src/utils/mobx/AsyncOperationWithStatus';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { Pager } from 'src/utils/mobx/Pager';
import { RequestHelper } from 'src/utils/RequestHelper';

const DEFAULT_TASKS_LIST_SIZE = 40;
const DEFAULT_TASKS_PAGE_NUMBER = 0;

export class AvailableTasksStoreClass extends BasicStore<TaskRepresentation> {
    infiniteScroll = true;

    api: BasicStoreApi<TaskRepresentation> = {
        loadList: async (...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);
            const resp =
                await RequestHelper.unwrapFromAxiosPromise<PageTaskRepresentation>(
                    taskManagerApi.listAvailable(
                        this.pager?.page || DEFAULT_TASKS_PAGE_NUMBER,
                        this.pager?.size || DEFAULT_TASKS_LIST_SIZE,
                        undefined,
                        options,
                    ),
                );

            this.pager.setTotal(resp.totalElements || 0);

            return resp.content || [];
        },
    };

    pager = new Pager(DEFAULT_TASKS_LIST_SIZE);

    itemDetailsFormKey = '';

    claimTaskAction = new AsyncOperationWithStatus((taskId: string) =>
        RequestHelper.unwrapFromAxiosPromise(taskManagerApi.claim(taskId)),
    );

    @action async claim(id: string) {
        await this.claimTaskAction.call(id);
        await this.loadList();
    }
}

export const AvailableTasksStore = new AvailableTasksStoreClass();
